/*
 * @Description: xxxx
 * @Author: yinj
 * @Date: 2021-01-20 16:13:04
 * @LastEditors: yinj
 * @LastEditTime: 2021-01-21 16:55:48
 */
export default {
  path: '/wenjuan/preview/:code',
  name: 'Wenjuan.Preview',
  component: () => import(/* webpackChunkName: "form" */ '@/views/modules/wenjuan/Preview.vue'),
  hiddenInMenu: true,
  meta: {
    title: '问卷预览',
    icon: 'database',
  },
};
